import { Record, List } from 'immutable';
import ContactListCounts from 'automation-ui-canvas/data/records/ContactListCounts';
import ContactListIds from 'automation-ui-canvas/data/records/ContactListIds';
export default class MetaData extends Record({
  contactListCounts: new ContactListCounts(),
  contactListIds: new ContactListIds(),
  succeededListId: null,
  triggeredByWorkflowIds: List()
}) {}